<template>
  <div>
    <div class="d-flex mb-3">
      <dropdown
        style="flex: 2;"
        :options="savingsTypeOptions"
        :value="benefit.savingsTypeId"
        :onChange="val => (benefit.savingsTypeId = val)"
        placeholder="Savings Type"
        :disabled="benefitLocked"
      />

      <dropdown
        style="flex: 1;"
        :options="confidenceOptions"
        :value="benefit.confidence"
        :onChange="val => (benefit.confidence = val)"
        :placeholder="benefitConfidenceLabel || 'Confidence'"
        :disabled="benefitLocked"
      />
    </div>
    <div class="d-flex mb-3">
      <dropdown
        class="flex-grow-1"
        :options="yearOptions"
        :value="benefit.yearEnding"
        :onChange="val => (benefit.yearEnding = val)"
        placeholder="Financial year"
        :disabled="benefitLocked"
      />
    </div>
    <div class="d-flex">
      <material-input
        :value="benefit.forecastedAmount"
        @input="
              val =>
                (benefit.forecastedAmount =
                  Number(val) === 0 ? null : Number(val))
            "
        type="number"
        :label="`Forecasted Amount`"
        :required="false"
        name="Forecasted Amount"
        :symbol="getCurrencySymbol()"
        :disabled="benefitLocked"
      />

      <div class="datepicker">
        <label>Forecasted Date</label>
        <datepicker
          :value="benefit.forecastedDate"
          mode="single"
          :onChange="date => updateDate(benefit, 'forecastedDate', date)"
          placeholder="Select date"
          class="datepicker"
          :disabled="benefitLocked"
        />
      </div>
    </div>
    <div v-if="approvalFlowAccess"> <!-- Hide these if the user removes himself as Owner while working on benefit realisation -->
      <transition name="expand-x">
        <div v-show="newApprovalMode">
          <div style="margin: 0 -10px; border-top: solid 1px #c6c6c6; height: 10px" />
        </div>
      </transition>
      <transition name="slide-y">
        <div v-if="newApprovalMode" style="overflow-y: visible; margin-top: 16px">
  <!--        <div v-if="newApprovalMode" style="margin: 0 -10px; border-top: solid 1px #c6c6c6;" />-->
          <div class="d-flex">
            <material-input
              :value="newApproval.amount"
              @input="newApproval.amount = Number($event) === 0 ? null : Number($event)
                "
              type="number"
              :label="`Realised Amount`"
              :required="false"
              name="Amount"
              :symbol="getCurrencySymbol()"
              :disabled="loadingApproval || (approvalState && !newApprovalMode)"
            />
            <div class="datepicker">
              <label>Realised Date</label>
              <datepicker
                :value="newApproval.date"
                mode="single"
                :onChange="date => updateDate(newApproval, 'date', date)"
                placeholder="Select date"
                class="datepicker"
                :disabled="loadingApproval || (approvalState && !newApprovalMode)"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>

<!--    Current benefit approval-->
    <div v-if="benefitApproval && !!approvalState && !newApprovalMode" class="approval-status">

      <div class="d-flex">
        <material-input
          :value="benefitApproval.realizedAmount"
          @input="() => {}"
          type="number"
          :label="`Realised Amount`"
          name="Amount"
          :symbol="getCurrencySymbol()"
          :disabled="true"
        />
        <div class="datepicker">
          <label>Realised Date</label>
          <datepicker
            :value="benefitApproval.realizedDate"
            :onChange="() => {}"
            mode="single"
            placeholder="Select date"
            class="datepicker"
            :disabled="true"
          />
        </div>
      </div>
<!--      <div v-if="approvalState === 'Pending'">-->
<!--        <span>Pending approval</span><br />-->
<!--      </div>-->
      <span v-if="approvalState === 'Pending'">
        {{`Approval requested by ${users[benefitApproval.requesterId].name} on`}} {{formatDate(benefitApproval.createdAt)}}
      </span>
      <span v-else-if="approvalState === 'Approved'">
        {{`Approved by ${users[benefitApproval.responderId].name} on`}} {{formatDate(benefitApproval.createdAt)}}
      </span>
      <span v-else-if="approvalState === 'Rejected'">
        {{`Rejected by ${users[benefitApproval.responderId].name} on`}} {{formatDate(benefitApproval.createdAt)}}
      </span>
      <span v-else-if="approvalState === 'Cancelled'">
        {{`Cancelled by ${users[benefitApproval.requesterId].name} on`}} {{formatDate(benefitApproval.createdAt)}}
      </span>

      <div v-if="benefitApproval.responderNotes">
        <span>Comment: {{ benefitApproval.responderNotes }}</span>
      </div>
      <div v-if="approvalFlowAccess && ['Approved', 'Rejected'].includes(approvalState)" class="d-flex justify-content-end">
        <div>
          <a class="button dense outlined" @click="startNewApproval">Amend</a>
        </div>
      </div>
    </div>

<!--    Benefit approval action buttons-->
    <div v-if="!!(benefit.id >= 1) && approvalFlowAccess">
      <div v-if="newApprovalMode" class="d-flex justify-content-end">
        <div class="d-flex">
            <a class="button secondary-button dense" @click="cancelNewApproval" :disabled="loadingApproval">Cancel</a>
          <a
            class="button outlined dense"
            @click="submitApprovalRequest"
            :disabled="!(!!newApproval.date && !!newApproval.amount) || loadingApproval">Realise</a>
        </div>
      </div>
      <div v-else class="d-flex justify-content-end">
        <div>
          <a v-if="!approvalState" class="button dense outlined" @click="startNewApproval">Realise</a>
          <a
            v-else-if="approvalState === 'Pending'"
            class="button dense outlined"
            @click="cancelApprovalRequest"
            :disabled="loadingApproval"
          >Cancel Request</a>
        </div>
      </div>
    </div>

    <img
      class="clear"
      src="~@/assets/icons/clear.svg"
      @click.stop.prevent="$emit('remove')"
    />
  </div>
</template>

<script>
import moment from "moment/moment";
import MaterialInput from './MaterialInput.vue';
import Dropdown from './Dropdown';
import Datepicker from './Datepicker';
import {mapGetters} from "vuex";

export default {
  name: "ProjectBenefit",
  components: {
    'material-input': MaterialInput,
    dropdown: Dropdown,
    Datepicker,},
  props: {
    benefit: {
      type: Object,
      required: true
    },
    savingsTypeOptions: {
      type: Array,
      default: () => ([])
    },
    benefitConfidenceLabel: {
      type: String,
      default: 'Confidence'
    },
    confidenceOptions: {
      type: Array,
      default: () => ([])
    },
    getCurrencySymbol :{
      type: Function,
      default: () => ('')
    },
    yearOptions: {
      type: Array,
      default: () => ([])
    },
    projectMembers: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    newApprovalMode: false,
    loadingApproval: false,
    newApproval: {
      amount: null,
      date: null
    },
    benefitCache: null
  }),
  methods: {
    updateDate(benefit, key, date) {
      if (date) {
        const new_date = moment(date, [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);
        const old_date = moment(benefit[key], [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);

        if (new_date && old_date && !new_date.isSame(old_date, 'd')) {
          benefit[key] = new_date.toISOString();
        }
      } else {
        benefit[key] = null;
      }
    },
    async startNewApproval() {
      const userCanAutoAccept = true;

      // TODO: We need to check that they have actually saved the project before retrying, thus the currProjectMembers computed property
      // Benefits get automatically accepted and the project doesn't need valid responders
      if(!userCanAutoAccept && !this.currProjectMembers.find(el => el.jobTitle === 'Finance')) {
        const options = {
          html: false,
          okText: 'Cancel',
          customClass: 'acada-confirm',
          animation: 'fade'
        };
        const errorMessage = 'This project does not contain any stakeholders that can approve benefits. Please add a stakeholder that has authority to approve benefits, save, then retry.'
        const message = {
          title: `Can't request benefit approval`,
          body: errorMessage,
        };

        await this.$dialog.alert(message, options);
        return;
      }

      this.cacheBenefit();
      this.newApprovalMode = true
    },
    cancelNewApproval(){
      this.newApprovalMode = false;
      this.newApproval.amount = null;
      this.newApproval.date = null;
      this.revertBenefitChanges();
    },
    submitApprovalRequest(){
      // Call requestNewBenefitApproval
      this.loadingApproval = true;
      const {
        id: benefitId,
        savingsTypeId,
        confidence,
        yearEnding,
        forecastedAmount,
        forecastedDate
      } = this.benefit;

      this.$store.dispatch('createBenefitApproval', {
        benefitId,
        savingsTypeId,
        confidence,
        yearEnding,
        forecastedAmount,
        forecastedDate,
        realizedAmount: this.newApproval.amount,
        realizedDate: this.newApproval.date
      })
        .then((benefitApproval) => {
          this.newApprovalMode = false;
          this.newApproval.amount = null;
          this.newApproval.date = null;
          this.clearBenefitCache();

          if(!Array.isArray(this.benefit.approvals)) this.$set(this.benefit, 'approvals', [])
          else this.benefit.approvals.splice(0);
          this.benefit.approvals[0] = benefitApproval;
          // if (benefitApproval.status === 'Approved' && !!benefitApproval.realizedAmount) {
          //   // TODO: Is this the best way to update the benefit approval?
          // TODO: We should be doing this through the store
          //   this.$set(this.benefit, 'amount', benefitApproval.realizedAmount);
          //   // this.benefit.amount = benefitApproval.realizedAmount
          //   console.log('Set bf amount', benefitApproval.realizedAmount)
          // }
          this.$emit('updated');
        })
        .catch(e => console.error(e))
        .finally(() => (this.loadingApproval = false))
    },
    formatDate(val){
      const date = moment(val)
      return date.isValid() ? date.format('DD MMM YYYY') : ''
    },
    cancelApprovalRequest(){
      if(!(this.benefitApproval && this.benefitApproval.id)) return;

      this.loadingApproval = true;
      this.$store.dispatch('cancelBenefitApproval', this.benefitApproval.id)
        .then((projectBenefitApproval) => {
            const oldApproval = this.benefit.approvals.find(el => el.id === projectBenefitApproval.id);
            if(oldApproval) {
              const index = this.benefit.approvals.indexOf(oldApproval);
              this.$set(this.benefit.approvals, index, Object.assign(oldApproval, {...projectBenefitApproval}));
            };
        })
        .catch(e => console.error(e))
        .finally(() => (this.loadingApproval = false))
    },
    cacheBenefit() {
      this.benefitCache = JSON.parse(JSON.stringify({
        savingsTypeId: this.benefit.savingsTypeId,
        confidence: this.benefit.confidence,
        yearEnding: this.benefit.yearEnding,
        forecastedAmount: this.benefit.forecastedAmount,
        forecastedDate: this.benefit.forecastedDate,
      }));
    },
    revertBenefitChanges() {
      if (this.benefitCache) {
        Object.keys(this.benefitCache).forEach(key => {
          this.benefit[key] = this.benefitCache[key];
        });
      }
      this.clearBenefitCache();
    },
    clearBenefitCache() {
      this.benefitCache = null;
    },
  },
  computed: {
    ...mapGetters(['app_user', 'users']),
    benefitLocked() {
      return !!this.approvalState && !this.newApprovalMode
    },
    benefitApproval(){
      return !Array.isArray(this.benefit.approvals) ? undefined :
        this.benefit.approvals
          .filter(el => el.status !== 'Cancelled')
          .sort((a, b) => new Date(b.requestedAt) - new Date(a.requestedAt))[0];
    },
    approvalState(){
      const approval = this.benefitApproval;
      if(!approval) return undefined;

      switch (approval.status) {
        case 'Pending': return 'Pending';
        case('Approved'): return 'Approved';
        case('Rejected'): return 'Rejected';
        default: return undefined
      }
    },
    approvalFlowAccess(){
      return this.projectMembers.filter(el => el.type === 'Owner').map(el => el.id).includes(this.app_user.id);
    },
    currProjectMembers(){
      //  This returns the project's projectMembers as it is in the Store, which should be the true version of the project
      const currProject = Object.values(this.$store.getters.projects).find(el => el.id === this.benefit.projectId);
      return currProject ? currProject.projectMembers : undefined;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.panel {
  padding: 25px 35px 0px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  margin-top: -8px;
  margin-bottom: 20px;

  .material-input {
    flex: 1;
  }

  &.benefit {
    // padding-top: 0;
    position: relative;

    .material-select {
      margin-right: 30px;
      min-width: 120px;

      &:first-child {
        min-width: 90px;
      }
    }

    .material-input {
      padding-right: 20px;
    }

    .clear {
      position: absolute;
      right: -73px;
      top: calc(50% - 38px);
      cursor: pointer;
      padding: 28px;
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover {
      .clear {
        opacity: 1;
      }
    }
  }
}

.datepicker {
  width: 215px;
// margin-bottom: 30px;
  margin-top: 0px;

  label {
    text-transform: uppercase;
    font-size: 10px;
    display: block;
    font-weight: 500;
    color: #929da9;
    margin-bottom: -10px;
  }
}

.approval-status {
  margin-bottom: 10px;
  span {
    font-size: 12px;
    color: $sidebar-color;
    opacity: 0.5;
  }
}

.slide-y-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  //-moz-transition-timing-function: ease-out;
  //-webkit-transition-timing-function: ease-out;
  //-o-transition-timing-function: ease-out;
  //transition-timing-function: ease-out;
}

.slide-y-leave-active {
  -moz-transition-duration: 0s;
  -webkit-transition-duration: 0s;
  -o-transition-duration: 0s;
  transition-duration: 0s;
  //-moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //-webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //-o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-y-enter-to, .slide-y-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-y-enter, .slide-y-leave-to {
  overflow: hidden;
  max-height: 0;
}

.expand-x-enter-active, expand-x-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.expand-x-enter-to, .expand-x-leave {
  margin: 0 0;
}

.expand-x-enter, .expand-x-leave-to {
  margin: 0 50%;
}

</style>
